import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ContentProductListParam} from '../../common/shared/api/nicolas/params/ContentProductListParam.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentProductListResultVo} from '../../common/shared/api/nicolas/vo/ContentProductListResultVo.interface';

/**
 * 콘텐츠 홈 작품 목록 조회
 *
 * Origin: pageNicolasApi.getContentHomeProductList
 * API: GET /api/v2/content/product/list
 */
export async function getContentProductList(
  params: ContentProductListParam,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentProductListResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/content/product/list',
    {
      method: 'GET',
      params: {...params},
    },
    options
  );
  return response.data;
}
